import { render, staticRenderFns } from "./ShipmentPrototypeCard.vue?vue&type=template&id=653c0f7e&scoped=true"
import script from "./ShipmentPrototypeCard.vue?vue&type=script&lang=js"
export * from "./ShipmentPrototypeCard.vue?vue&type=script&lang=js"
import style0 from "./ShipmentPrototypeCard.vue?vue&type=style&index=0&id=653c0f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c0f7e",
  null
  
)

export default component.exports